<template>
  <IconLucideSend />
</template>
